import React from 'react';
import CajaLogin from '../components/Login/CajaLogin';

import escondida from "../assets/img/escondida.jpg";

import './Login.css';

const Login = (props) => {
	return (
		<>
			<div className="sectionLogin">
				
				<div className="imgBx">
					<img src={escondida} alt="home"/>
				</div>
				
				<div className="contentBx">
					<CajaLogin className="formBx"/>
				</div>
			
			</div>
		</>	
	)
}

export default Login;
